<div class="flex items-end">
  @if (_breadcrumbItems && _breadcrumbItems.length > 0) {
    <a class="clickable" [routerLink]="_breadcrumbItems[0].routerLink">{{ _breadcrumbItems[0].label }}</a>
  }
  @if (_breadcrumbItems && _breadcrumbItems.length > 1) {
    <div>></div>
    <a class="clickable text-4xl" [routerLink]="_breadcrumbItems[1].routerLink">{{ _breadcrumbItems[1].label }}</a>
  }
  @if (_breadcrumbItems && _breadcrumbItems.length > 2) {
    <div class="text-4xl">></div>
    <a class="clickable text-3xl" [routerLink]="_breadcrumbItems[2].routerLink">{{ _breadcrumbItems[2].label }}</a>
  }
</div>

